import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_35: FaireProductEntity = {
  token: "legacy_prod_abbott-35",
  type: "product",
  name: 'All Purpose Scissors Orange 8" L',
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/39ad76ad0503fe087e7f0c18c4dfbf0e67ef96acd20d35ef346c241d37b025aa.jpeg",
  priceDollars: 6,
  msrpDollars: 12,
  subcategory: "Scissors & Tools",
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_kitchen-tabletop"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
